export const BASE_URL = "https://ms.readygo.org.cn/ssi-auth";
// export const BASE_URL = "http://192.168.3.172:12340/ssi-auth";
// export const BASE_URL = "http://192.168.3.30:12340/ssi-auth";
// axios.defaults.baseURL = "http://192.168.3.174:12340/ssi-auth";
//  axios.defaults.baseURL = "https://ms.readygo.org.cn/ssi-auth";
